export var RankEffectiveBetStatusType;
(function (RankEffectiveBetStatusType) {
    RankEffectiveBetStatusType["SUCCESS"] = "success";
    RankEffectiveBetStatusType["UPGRADE"] = "upgrade";
    RankEffectiveBetStatusType["DOWNGRADE"] = "downgrade";
})(RankEffectiveBetStatusType || (RankEffectiveBetStatusType = {}));
//# sourceMappingURL=RankEffectiveBetStatusType.js.map